import { Route, Routes } from "react-router-dom";
import "./App.css";
import { Navbar } from "./components/pages/Navbar";
import Login from "./components/pages/Login";
import Create from "./components/pages/create";
import Edit from "./components/pages/edit";
import React, { useState, useEffect } from "react";
import About from "./components/pages/About";
import Names from "./components/pages/Names";
import Footer from "./components/pages/Footer";
import FAQ from "./components/pages/Faq";
import Creation from "./components/pages/Creation";
import ScrollToTop from "./components/pages/scrollToTop";
import PasswordResetRequest from "./components/pages/PasswordResetRequest";
import PasswordReset from "./components/pages/PasswordReset";

function App() {

  const [loginStatus, setLoginStatus] = useState("");
  const [uEmail, setUEmail] = useState("");

  return (
    <div className="App">
      <Navbar loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<About loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>} />
        <Route path="/login" element={<Login loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>} />
        <Route path="/logout" element={<Login loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>} />
        <Route path="/create" element={<Create loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>}/>
        <Route path="/about" element={<About loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>}/>
        <Route path="/faq" element={<FAQ loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>}/>
        <Route path="/creation" element={<Creation loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>}/>
        <Route path="/names" element={<Names loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>}/>
        <Route path="/names/:id" element={<Edit loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>}/>
        <Route path="/password-reset" element={<PasswordResetRequest />} />
        <Route path="/password-reset/:token" element={<PasswordReset />} />
        <Route path="/password-reset-request" element={<PasswordResetRequest />} />
      </Routes>
      <Footer/>
    </div>
    
  );
}

export default App;